import { Autocomplete, Box, TextField, Typography } from "@mui/material";

import { formatPriceHistoryFilterCount } from "./pricingReportProductFilter";

function PricingReportRetailerAutocomplete({
  options = [],
  value,
  onChange,
  multiple = false,
  showCounts = true,
  label,
  loading = false,
  disabled = false,
  fullWidth = true,
  size = "small",
}) {
  const inputLabel = label ?? (multiple ? "Retailers" : "Retailer");

  const renderOption = showCounts
    ? (props, option) => {
        const { key: _ignoredMuiKey, ...listItemProps } = props;
        const countLabel = formatPriceHistoryFilterCount(option.priceHistoryCount);
        return (
          <Box
            component="li"
            key={option.name}
            {...listItemProps}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 1,
              width: "100%",
            }}
          >
            <Box component="span" sx={{ minWidth: 0, flex: 1 }}>
              {option.name}
            </Box>
            {countLabel ? (
              <Typography
                component="span"
                variant="body2"
                color="text.secondary"
                sx={{ flexShrink: 0, fontVariantNumeric: "tabular-nums" }}
              >
                {countLabel}
              </Typography>
            ) : null}
          </Box>
        );
      }
    : undefined;

  const sharedProps = {
    fullWidth,
    size,
    options,
    getOptionLabel: (retailer) => retailer?.name ?? "",
    isOptionEqualToValue: (left, right) => left?.name === right?.name,
    renderOption,
    renderInput: (params) => <TextField {...params} label={inputLabel} />,
    loading,
    disabled,
  };

  if (multiple) {
    return (
      <Autocomplete
        {...sharedProps}
        multiple
        value={value ?? []}
        onChange={(_, nextRetailers) => onChange(nextRetailers)}
      />
    );
  }

  return (
    <Autocomplete
      {...sharedProps}
      value={value ?? null}
      onChange={(_, nextRetailer) => onChange(nextRetailer)}
    />
  );
}

export default PricingReportRetailerAutocomplete;
